import React, { CSSProperties } from "react";

export default function IconLogOut(props: {
	className?: string;
	style?: CSSProperties;
	color?: string;
	size?: number;
}) {
	return (
		<svg
			className={props.className}
			style={props.style}
			xmlns="http://www.w3.org/2000/svg"
			width={props.size ?? 24}
			height={props.size ?? 24}
			viewBox="0 0 24 24"
		>
			<path
				d="M14 9.5C14.5523 9.5 15 9.05228 15 8.5V8C15 5.79086 13.2091 4 11 4L7 4C4.79086 4 3 5.79086 3 8L3 16C3 18.2091 4.79086 20 7 20H11C13.2091 20 15 18.2091 15 16V15.5C15 14.9477 14.5523 14.5 14 14.5C13.4477 14.5 13 14.9477 13 15.5V16C13 17.1046 12.1046 18 11 18H7C5.89543 18 5 17.1046 5 16L5 8C5 6.89543 5.89543 6 7 6L11 6C12.1046 6 13 6.89543 13 8V8.5C13 9.05229 13.4477 9.5 14 9.5Z"
				fill={props.color ?? "black"}
			/>

			<path
				d="M9 11C8.44771 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H16.6008V16L20.6247 12.7809C21.1251 12.3805 21.1251 11.6195 20.6247 11.2191L16.6008 8L16.6008 11L9 11Z"
				fill={props.color ?? "black"}
			/>
		</svg>
	);
}
